<script setup>
    import { ref, reactive } from 'vue';
    // import * as bootstrap from 'bootstrap'; // needed if we want to make modal disappear in saveNewUser() ?
    import { vMaska } from 'maska';
    import VueDatePicker from '@vuepic/vue-datepicker';
    import axios from 'axios';

    const props = defineProps(['saveUrl']);

    const newUser = ref({
        anrede: 'Firma', //not meant to be actual anrede, but difference between private and enterprise customer
        name1: '',
        name2: '',
        strasse: '',
        plz: '',
        ort: '',
        land: '',
        email: '',
        telefon: '',
        iban: '',
        geburtsdatum: '',
        vertragsbeginn: '',
        zahlart: '',
        gruppenzaehler: 9999
    });
    const bindedObject = reactive({});
    const submitResult = ref(null);
    const submitError = ref(null);

    const userPassword = ref("");

    const vertragsbeginnAnzeige = ref("");
    const geburtsdatumAnzeige = ref("");

    function unformatDate(date){
        let tempDate = new Date(date);


        let month = (tempDate.getMonth() + 1).toString();
        if(month.length == 1){
            month = "0" + month;
        }
        let day = (tempDate.getDate()).toString();
        if(day.length == 1){
            day = "0" + day;
        }

        return "" + tempDate.getFullYear() + month + day;
    }



    async function saveNewUser() {
        submitError.value = null;
        submitResult.value = null;
        userPassword.value = "";

        newUser.value.vertragsbeginn = unformatDate(vertragsbeginnAnzeige.value);
        newUser.value.geburtsdatum = unformatDate(geburtsdatumAnzeige.value);

        newUser.value.iban = bindedObject.unmasked;
        await axios.post(props.saveUrl, newUser.value)
        .then(function (response) {
            submitResult.value = response;
            // if we want the modal to disappear after 2 seconds, comment in this block and the bootstrap include above.
             /*setTimeout(function() {
                 const currentModal = document.querySelector('#createUser');
                 const modal = bootstrap.Modal.getInstance(currentModal);
                 modal.hide();
             }, 2000);
             setTimeout(function() {
                 window.location.reload();
             }, 2500); */

             userPassword.value = response.data.userPassword;

        }).catch(function (error) {
            submitError.value = error;

        });
    }

</script>
<template>
    <form @submit.prevent="saveNewUser">
        <div class="form-group">
            <label for="anrede">Privatperson oder Firma</label>
            <select
                v-model="newUser.anrede"
                :class="{
                    'form-select form-control': true,
                    'form-select is-valid': (submitResult !== null),
                    'form-select is-invalid': (submitError !== null && typeof submitError.response.data.anrede !== 'undefined'),
                }"
            >
                <option value="Frau">Frau</option>
                <option value="Herr">Herr</option>
                <option value="Divers">Divers</option>
                <option value="Firma">Firma</option>
            </select>
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.anrede !== 'undefined')">
                {{ submitError.response.data.anrede[0] }}
            </div>
        </div>

        <div class="form-group">
            <label for="name1">Nachname</label>
            <input id="name1"
                type="text"
                v-model="newUser.name1"
                :class="{
                    'form-control': true,
                    'is-valid': (submitResult !== null),
                    'is-invalid': (submitError !== null && typeof submitError.response.data.name1 !== 'undefined'),
                }"
            />
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.name1 !== 'undefined')">
                {{ submitError.response.data.name1[0] }}
            </div>
        </div>

        <div class="form-group">
            <label for="name2">Vorname</label>
            <input id="name2"
                type="text"
                v-model="newUser.name2"
                :class="{
                    'form-control': true,
                    'is-valid': (submitResult !== null),
                    'is-invalid': (submitError !== null && typeof submitError.response.data.name2 !== 'undefined'),
                }"
            />
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.name2 !== 'undefined')">
                {{ submitError.response.data.name2[0] }}
            </div>
        </div>

        <div class="form-group">
            <label for="strasse">Straße</label>
            <input id="strasse"
                type="text"
                v-model="newUser.strasse"
                :class="{
                    'form-control': true,
                    'is-valid': (submitResult !== null),
                    'is-invalid': (submitError !== null && typeof submitError.response.data.strasse !== 'undefined'),
                }"
            />
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.strasse !== 'undefined')">
                {{ submitError.response.data.strasse[0] }}
            </div>
        </div>

        <div class="form-group">
            <label for="ort">Ort</label>
            <input id="ort"
                type="text"
                v-model="newUser.ort"
                :class="{
                    'form-control': true,
                    'is-valid': (submitResult !== null),
                    'is-invalid': (submitError !== null && typeof submitError.response.data.ort !== 'undefined'),
                }"
            />
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.ort !== 'undefined')">
                {{ submitError.response.data.ort[0] }}
            </div>
        </div>

        <div class="form-group">
            <label for="plz">Postleitzahl</label>
            <input id="plz"
                type="text"
                v-model="newUser.plz"
                :class="{
                    'form-control': true,
                    'is-valid': (submitResult !== null),
                    'is-invalid': (submitError !== null && typeof submitError.response.data.plz !== 'undefined'),
                }"
            />
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.plz !== 'undefined')">
                {{ submitError.response.data.plz[0] }}
            </div>
        </div>

        <div class="form-group">
            <label for="land">Land</label>
            <select
                v-model="newUser.land"
                :class="{
                    'form-select form-control': true,
                    'form-select is-valid': (submitResult !== null),
                    'form-select is-invalid': (submitError !== null && typeof submitError.response.data.land !== 'undefined'),
                }">
                <option value="Deutschland">Deutschland</option>
                <option value="Belgien">Belgien</option>
                <option value="Niederlande">Niederlande</option>
                <option value="Luxemburg">Luxemburg</option>
                <option value="Frankreich">Frankreich</option>
                <option value="Österreich">Österreich</option>
                <option value="Schweiz">Schweiz</option>
                <option value="Italien">Italien</option>
                <option value="Rumänien">Rumänien</option>
                <option value="Spanien">Spanien</option>
            </select>
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.land !== 'undefined')">
                {{ submitError.response.data.land[0] }}
            </div>
        </div>

        <div class="form-group">
            <label for="email">E-Mail</label>
            <input id="email"
                type="text"
                v-model="newUser.email"
                :class="{
                    'form-control': true,
                    'is-valid': (submitResult !== null),
                    'is-invalid': (submitError !== null && typeof submitError.response.data.email !== 'undefined'),
                }"
            />
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.email !== 'undefined')">
                {{ submitError.response.data.email[0] }}
            </div>
        </div>

        <div class="form-group">
            <label for="telefon">Telefonnummer</label>
            <input id="telefon"
                type="text"
                v-model="newUser.telefon"
                :class="{
                    'form-control': true,
                    'is-valid': (submitResult !== null),
                    'is-invalid': (submitError !== null && typeof submitError.response.data.telefon !== 'undefined'),
                }"
            />
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.telefon !== 'undefined')">
                {{ submitError.response.data.telefon[0] }}
            </div>
        </div>

        <div class="form-group">
            <label  for="zahlart">Zahlart</label>
            <select id="zahlart" v-model="newUser.zahlart" class="form-select form-control">
                <option value="Überweisung">Überweisung</option>
                <option value="SEPA-Basislastschrift (CORE)">IBAN</option>
            </select>
        </div>


        <div v-if="newUser.zahlart === 'SEPA-Basislastschrift (CORE)'" class="form-group">
            <label for="iban">IBAN</label>
            <input
                id="iban"
                type="text"
                v-maska="bindedObject"
                v-model="newUser.iban"
                data-maska="@@## **** **** **** **** **** **** **** **"
                :class="{
                    'form-control': true,
                    'is-valid': (submitResult !== null),
                    'is-invalid': (submitError !== null && typeof submitError.response.data.iban !== 'undefined'),
                }"
            />
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.iban !== 'undefined')">
                {{ submitError.response.data.iban[0] }}
            </div>
        </div>



        <div class="form-group">
            <label for="geburtsdatum">Geburtsdatum</label>
            <VueDatePicker
                v-model="geburtsdatumAnzeige"
                text-input
                format="dd.MM.yyyy"
                locale="de"
                :enable-time-picker="false"
                selectText="Auswählen"
                cancelText="Abbrechen"
            />
        </div>

        <div class="form-group">
            <label for="vertragsbeginn">Vertragsbeginn</label>
            <VueDatePicker
                v-model="vertragsbeginnAnzeige"
                text-input
                format="dd.MM.yyyy"
                locale="de"
                :enable-time-picker="false"
                selectText="Auswählen"
                cancelText="Abbrechen"
            />
        </div>

        <div class="form-group">
            <label for="gruppenzaehler">Gruppenzaehler</label>
            <input id="gruppenzaehler"
                type="number"
                min="0"
                step="1"
                max="9999"
                v-model="newUser.gruppenzaehler"
                :class="{
                    'form-control': true,
                    'is-valid': (submitResult !== null),
                    'is-invalid': (submitError !== null && typeof submitError.response.data.gruppenzaehler !== 'undefined'),
                }"
            />
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.gruppenzaehler !== 'undefined')">
                {{ submitError.response.data.gruppenzaehler[0] }}
            </div>
        </div>
        <div v-if="userPassword != ''">

            <h4>Passwort:</h4>
            <input type="text" readonly class="form-control" :value=userPassword> </input>

        </div>
        <p>Alle Felder Pflichtfelder.</p>
        <button
            type="submit"
            class="btn btn-primary">
            Rechnungsempfänger erstellen
        </button>
    </form>

    <div class="alert alert-success" role="alert" v-if="submitResult !== null && (submitResult.status === 201 || submitResult.status === 200)">
        <span>Rechnungsempfänger erfolgreich angelegt.</span>
    </div>
    <div v-else-if="submitError !== null" class="alert alert-error">
        <span>Rechnungsempfänger konnte nicht angelegt werden!</span>
    </div>

</template>
